import Vue from 'vue'
import App from './App.vue'
import url from './tool/url'

Vue.config.productionTip = false

import echarts from 'echarts';

Vue.prototype.$echarts = echarts;

import axios from 'axios';

Vue.prototype.$axios = axios;

Vue.prototype.$url = url

new Vue({
  render: h => h(App),
}).$mount('#app')